export const TASKS_URL = '/api/tasks';

export const MULTIPART_CONFIG = { headers: { 'Content-Type': 'multipart/form-data' } };

export const TASK_INCLUDE_CONFIG = {
  params: { include: ['TaskType', 'SubmittedDocuments'] },
  paramsSerializer: { indexes: null },
};
